export const getSkillsSorted = <T extends { level?: number }>(skills: T[]): T[] => {
  return [...skills].sort((a, b) => {
    if (!a?.level) return 1;
    if (!b?.level) return -1;

    return b?.level - a?.level;
  });
};

export const _getSkillsSorted = <T extends { level?: number; skill: { id?: string; label: string; iso?: boolean } }>(
  skills: T[],
): T[] => {
  const sortedSkills = getSkillsSorted(skills);

  const t: T[] = sortedSkills.map((sk) => {
    return {
      level: sk.level,
      skill: {
        id: sk.skill.id,
        label: sk.skill.label,
      },
    } as T;
  });
  return t;
};
